export const sortOptions: { title: string; value: string }[] = [
	{ title: 'A - Z', value: 'name-asc' },
	{ title: 'Z - A', value: 'name-desc' },
	{ title: 'Most Recent', value: 'updatedAt-desc' },
];
